"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZodValidationErrorResponse = exports.ZodValidationError = exports.ZodIssue = void 0;
const zod_1 = require("zod");
exports.ZodIssue = zod_1.z.object({
    /** The type of validation that was performed, e.g. email */
    validation: zod_1.z.string().optional(),
    /** The validation response code, e.g. invalid_string */
    code: zod_1.z.string().optional(),
    /** A human readable, but not necessarily customer-friendly message */
    message: zod_1.z.string().optional(),
    /** The path that failed validation */
    path: zod_1.z.array(zod_1.z.union([zod_1.z.string(), zod_1.z.number()])).optional(),
});
exports.ZodValidationError = zod_1.z.object({
    name: zod_1.z.literal('ZodError'),
    issues: zod_1.z.array(exports.ZodIssue),
});
/** The Zod schema that represents the structure of a JSON object returned when a TSRest response fails its Zod
 * request validation */
exports.ZodValidationErrorResponse = zod_1.z.object({
    // I don't know what type paramsResult should be, but we don't need it right now
    paramsResult: zod_1.z.unknown(),
    // I don't know what type headersResult should be, but we don't need it right now
    headersResult: zod_1.z.unknown(),
    // I don't know what type queryResult should be, but we don't need it right now
    queryResult: zod_1.z.unknown(),
    bodyResult: exports.ZodValidationError.optional(),
});
//# sourceMappingURL=zodTypes.js.map